<template>
  <div v-if="pageLoading">
    <b-spinner label="Loading"></b-spinner>
  </div>

  <div v-else>
    <br />
    <br />
    <br />
    <i class="far fa-check-circle fa-5x success"></i>

    <div class="page-header">
      Payment Successful
    </div>

    <div class="page-sub-header">
      We've added the credits to your account and sent a receipt to
      <strong>{{ $auth.user.email }}. </strong>
      <br />
      You may need to refresh this webpage to display your new credits.
    </div>

    <section class="transaction-summary">
      <b-table
        class="custom-table align-middle"
        borderless
        thead-class="hidden-header"
        :items="transactionSummary"
        medium
      >
        <!-- https://dribbble.com/shots/7052984-Recharge-Successful -->
        <template slot="cell(description)" slot-scope="row">
          <strong>{{ row.item.description }}</strong>
        </template>
      </b-table>
    </section>

    <b-button to="/robots" variant="primary">Available Robots</b-button>
  </div>
</template>

<script>
import StripeActions from "@/services/api/controllers/stripe";

export default {
  async mounted() {
    try {
      this.pageLoading = true;
      const accessToken = await this.$auth.getTokenSilently();

      const sessionInformation = await StripeActions.showSession(
        this.$route.query.session_id,
        accessToken
      );
      const priceInDollars = sessionInformation.amount_total / 100;
      const credits = parseInt(sessionInformation.metadata.credits);

      // Step 1: Set the date
      let d = new Date();
      let month = "" + (d.getMonth() + 1);
      let day = "" + d.getDate();
      let year = d.getFullYear();

      if (month.length < 2) month = "0" + month;
      if (day.length < 2) day = "0" + day;

      this.transactionSummary[0].value = [year, month, day].join("-");

      // Step 2: Set the credits
      this.transactionSummary[2].value = credits;

      // Step 3: Set the payment amount
      this.transactionSummary[3].value = priceInDollars.toLocaleString(
        "en-US",
        { style: "currency", currency: "USD" }
      );

      // Step 4: Update user's credit count
      this.$auth.credits = (
        await Users.show(this.$auth.user.email, accessToken)
      ).credits;

      return;
    } catch (error) {
      this.pageMessage = `Failed to grab receipt information`;
      this.pageVariant = "warning";
    } finally {
      this.pageLoading = false;
    }
  },

  data: function() {
    return {
      formattedDate: null,

      pageLoading: false,

      transactionSummary: [
        { description: "Date", value: null },
        { description: "Email", value: this.$auth.user.email },
        { description: "Credits", value: null },
        { description: "Amount", value: null }
      ]
    };
  }
};
</script>

<style>
/* Hidden header can't be scoped or else it won't work */
.hidden-header {
  display: none;
}
</style>

<style scoped>
.page-header {
  color: rgb(29, 29, 31);
  font-family: "Montserrat", sans-serif;
  font-size: 3.333vw;
  font-weight: 500;
  line-height: 1.111vw;
  letter-spacing: 0px;
  margin: 1.389vw;
}

.page-sub-header {
  color: rgb(79, 79, 85);
  font-family: "Montserrat", sans-serif;
  font-size: 1.481vw;
  font-weight: 400;
  line-height: 2.222vw;
  letter-spacing: 0.125px;
  margin: 1.389vw;
}

.success {
  color: #42b983;
}

.transaction-summary {
  background-color: white;
  border-radius: 1rem;
  color: #191970;
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: 0 2.778vw;
  margin: 0 auto;
  width: 50%;
}

.transaction-summary.custom-sub-header {
  color: #191970;
  font-size: 1.5em;
  font-weight: normal;
  padding: 1rem;
}

.transaction-summary.summation {
  font-size: 1em;
}

.transaction-summary .custom-table {
  background: rgb(228, 225, 225);
  border-radius: 10px;
  font-family: "Montserrat", sans-serif;
  font-size: 1em;
  font-weight: normal;
  margin: 1.852vw;
  text-align: center;
}

.transaction-summary .custom-table td {
  color: #191970;
  font-size: 0.9em;
  margin: 0 auto;
}
</style>
